import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-ea183cf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = { class: "flex mt-3" }
const _hoisted_3 = { class: "dark:text-white" }
const _hoisted_4 = { class: "ml-auto dark:text-white" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-xl text-left dark:text-white" }, "Food", -1))
const _hoisted_6 = { class: "border-black border rounded-2xl mt-2 pt-3 px-3 shadow-lg filter" }
const _hoisted_7 = { class: "grid grid-cols-5 text-center" }
const _hoisted_8 = { class: "text-left dark:text-white" }
const _hoisted_9 = { class: "dark:text-white" }
const _hoisted_10 = { class: "flex gap-4 justify-center dark:text-white" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "dark:text-white" }
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2.5" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 dark:text-white text-xl text-left" }, "Drinks", -1))
const _hoisted_18 = { class: "border-black border rounded-2xl mt-2 pt-3 px-3 shadow-lg filter" }
const _hoisted_19 = { class: "grid grid-cols-6 text-center items-center" }
const _hoisted_20 = { class: "dark:text-white text-left" }
const _hoisted_21 = {
  key: 0,
  class: "dark:text-white"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "dark:text-white" }
const _hoisted_26 = {
  key: 0,
  class: "ml-2.5 dark:text-white"
}
const _hoisted_27 = { class: "flex flex-col" }
const _hoisted_28 = { class: "flex gap-4 justify-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "flex gap-4 justify-center"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "dark:text-white" }
const _hoisted_38 = {
  key: 0,
  class: "dark:text-white"
}
const _hoisted_39 = { class: "flex flex-col" }
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = ["disabled", "onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2.5" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 dark:text-white text-xl text-left" }, "Beer", -1))
const _hoisted_44 = { class: "border-black border rounded-2xl mt-2 pt-3 px-3 shadow-lg filter" }
const _hoisted_45 = { class: "grid grid-cols-5 text-center items-center" }
const _hoisted_46 = { class: "dark:text-white text-left" }
const _hoisted_47 = { class: "flex flex-col dark:text-white" }
const _hoisted_48 = { class: "flex flex-col dark:text-white" }
const _hoisted_49 = { class: "flex gap-4 justify-center" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "flex gap-4 justify-center" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "flex flex-col" }
const _hoisted_58 = { class: "dark:text-white" }
const _hoisted_59 = { class: "dark:text-white" }
const _hoisted_60 = { class: "flex flex-col" }
const _hoisted_61 = ["onClick", "disabled"]
const _hoisted_62 = ["onClick", "disabled"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2.5" }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-xl text-left dark:text-white" }, "Order Summary", -1))
const _hoisted_65 = { class: "border-black border rounded-2xl mt-2 p-3 shadow-lg filter" }
const _hoisted_66 = {
  key: 0,
  class: "dark:text-white"
}
const _hoisted_67 = { class: "grid grid-cols-2 mb-2.5" }
const _hoisted_68 = { class: "flex items-center" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "dark:text-white" }
const _hoisted_71 = {
  key: 0,
  class: "dark:text-white"
}
const _hoisted_72 = {
  key: 1,
  class: "dark:text-white"
}
const _hoisted_73 = {
  key: 2,
  class: "dark:text-white"
}
const _hoisted_74 = {
  key: 3,
  class: "dark:text-white"
}
const _hoisted_75 = { class: "dark:text-white" }
const _hoisted_76 = { class: "dark:text-white" }
const _hoisted_77 = {
  key: 2,
  class: "grid grid-cols-2 mt-2.5"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-1 dark:text-white" }, "Total", -1))
const _hoisted_79 = { class: "dark:text-white" }
const _hoisted_80 = { class: "flex flex-col w-64" }

import {ref, shallowRef, reactive, computed, onMounted} from 'vue'
import { useRouter } from 'vue-router';

interface addedItemType {
    name: string,
    cold: boolean | undefined,
    price: number,
    qty: number,
    total:number,
    temp?: boolean,
    bigPrice? :boolean | undefined,
}

interface foodItem {
    name: string,
    price: number,
    qty: number,
}

interface drinksItem {
    name: string,
    price: number,
    qty: number,
    qty2?: number,
    temp?: boolean,
    bigPrice? :number,
}

interface beerItem {
    name: string,
    price: number,
    qty: number,
    qty2: number,
    bigPrice:number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersView',
  props: {
    index: String
},
  setup(__props) {

const p = __props;



let time = shallowRef('') 
let currentTime = ()=>{
    let date = new Date
    time.value = date.toDateString() +' '+ date.toLocaleTimeString()
}
currentTime()
setInterval(currentTime,1000)
/* interface item {
    name: string,
    price: number,
    qty: number,
    qty2?: number,
    temp?: boolean,
    bigPrice? :number,
} */

let addedItem = ref<addedItemType[]>([]) 

let addItem = (name :string,price :number,qty :number,cold?:boolean )=>{
    let findDrink = drinks.find(drink=>drink.name == name)
    let bigPrice  = undefined
    if(findDrink){
        bigPrice = (findDrink.bigPrice==price)
    }
    let findBeer = beer.find(b=>b.name == name)
    if(findBeer){
        bigPrice = (findBeer.bigPrice==price)
    }
    if(!findDrink && !findBeer){
        
        let findExistingFood = addedItem.value.find((item:addedItemType)=>item.name==name)
        if(findExistingFood){
            findExistingFood.total = findExistingFood.total+ (price*qty)
            findExistingFood.qty = findExistingFood.qty+ (qty)
        }else{
            addedItem.value.push({
                name:name,
                cold:cold,
                price:price,
                qty:qty,
                total:price*qty,
                bigPrice:bigPrice
            })
        }
    }
    if(findDrink){
        let findExistingDrink = addedItem.value.find((item:addedItemType)=>item.name==name && item.cold == cold && item.price == price)
        if(findExistingDrink){
            findExistingDrink.total = findExistingDrink.total+ (price*qty)
            findExistingDrink.qty = findExistingDrink.qty+ (qty)
        }else{
            addedItem.value.push({
                name:name,
                cold:cold,
                price:price,
                qty:qty,
                total:price*qty,
                bigPrice:bigPrice
            })
        }
    }
    if(findBeer){
        let findExistingBeer = addedItem.value.find((item:addedItemType)=>item.name==name && item.price == price)
        if(findExistingBeer){
            findExistingBeer.total = findExistingBeer.total+ (price*qty)
            findExistingBeer.qty = findExistingBeer.qty+ (qty)
        }else{
            addedItem.value.push({
                name:name,
                cold:cold,
                price:price,
                qty:qty,
                total:price*qty,
                bigPrice:bigPrice
            })
        }
    }
}

let removeItem =( index :number)=>{
    addedItem.value.splice(index,1)
}

let totalCost = computed(()=>{ 
    let total = 0
    addedItem.value.forEach((item :addedItemType)=> {
        total = total+ item.total
    });
    return Math.round(total*100)/100
})

const router = useRouter()
const resetTemporary = () =>{
    if(p.index!=undefined){
        let item = localStorage.getItem('temporaryOrders')
        if(item!=null){
            let parsedItem = JSON.parse(item)
            parsedItem[parseFloat(p.index)-1] = 0
            localStorage.setItem('temporaryOrders',JSON.stringify(parsedItem))
        }
    }
}

const saveOrder = ()=>{
    resetTemporary()
    if(p.index!=undefined){
        let savedOrders2 = {saveOrders:addedItem.value,timestamp:time.value,table:p.index,total:totalCost.value}
        let item = localStorage.getItem('savedOrders')
        if(item!=null){
            let existingOrder = JSON.parse(item)
            existingOrder.push(savedOrders2)
            localStorage.setItem('savedOrders',JSON.stringify(existingOrder))
            router.push('/')
        }
    }
}

const saveTemporary = () =>{
    if(p.index!=undefined){
        let item = localStorage.getItem('temporaryOrders')
        if(item!=null){
            let parsedItem = JSON.parse(item)
            parsedItem[parseFloat(p.index)-1] = addedItem.value
            localStorage.setItem('temporaryOrders',JSON.stringify(parsedItem))
            router.push('/')
        }
    }
}

onMounted(()=>{
    if(p.index!=undefined){
        let item = localStorage.getItem('temporaryOrders')
        if(item!=null && JSON.parse(item)[parseFloat(p.index)-1]!=0){
            addedItem.value = JSON.parse(item)[parseFloat(p.index)-1]
        }
    }
})

const food :foodItem[] =reactive([ 
    {
    name: '火锅',
    price:36,
    qty:0
    },
    {
    name: '肉类/麻辣汤',
    price:7,
    qty:0
    },
    {
    name: '火锅材料',
    price:5,
    qty:0
    },
    {
    name: '腌熏鸭',
    price:8,
    qty:0
    },
    {
    name: '蔬菜/豆腐',
    price:3,
    qty:0
    },
    {
    name: '鸡蛋/白饭/快熟面',
    price:1.5,
    qty:0
    },
    {
    name: '伊面(粗)/TOMYAM面',
    price:2,
    qty:0
    },
    {
    name: '虾滑',
    price:12,
    qty:0
    }
])

const drinks :drinksItem[]=reactive([
    {
    name: '汽水',
    price:3,
    qty:0,
    temp: true,
    },
    {
    name: '罗汉果',
    price:1.8,
    qty:0,
    qty2:0,
    temp: true,
    bigPrice: 3.5
    },
    {
    name: '蝶豆花',
    price:1.8,
    qty:0,
    qty2:0,
    temp: true,
    bigPrice: 3.5
    },
    {
    name: '八宝',
    price:1.8,
    qty:0,
    qty2:0,
    temp: true,
    bigPrice: 3.5
    },
    {
    name: '凉茶',
    price:1.8,
    qty:0,
    qty2:0,
    temp: true,
    bigPrice: 3.5
    },
    {
    name: '菊花',
    price:1.8,
    qty:0,
    qty2:0,
    temp: true,
    bigPrice: 3.5
    },
    {
    name: 'Orange Juice',
    price:3.5,
    qty:0,
    qty2:0,
    bigPrice: 6.5
    },
    {
    name: 'Apple Juice',
    price:3.5,
    qty:0,
    qty2:0,
    bigPrice: 6.5
    },
    {
    name: 'Lemon Juice',
    price:3.5,
    qty:0,
    qty2:0,
    bigPrice: 6.5
    },
    {
    name: '西瓜汁',
    price:3.5,
    qty:0,
    qty2:0,
    bigPrice: 6.5
    },
    {
    name: '爽爽冰/carrot',
    price:3.5,
    qty:0,
    qty2:0,
    bigPrice: 6.5
    },
     {
    name: 'Nascafe/爽爽冰coffee/Milo',
    price:3.5,
    qty:0,
    qty2:0,
    bigPrice: 6.5
    },
    {
    name: '白开水',
    price:0.8,
    qty:0,
    qty2:0,
    temp: true,
    bigPrice: 1.2
    },
])

const beer :beerItem[] =reactive([
{
    name: 'TIGER',
    price: 0,
    qty:0,
    qty2:0,
    bigPrice: 20
},
{
    name: 'CARLSBERG',
    price: 0,
    qty:0,
    qty2:0,
    bigPrice: 20
},
{
    name: 'GUINNESS',
    price: 0,
    qty:0,
    qty2:0,
    bigPrice: 22
}
])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "Table No: " + _toDisplayString(__props.index), 1),
      _createElementVNode("div", _hoisted_4, "Date: " + _toDisplayString(_unref(time)), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(food, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.price), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: ($event: any) => (item.qty--)
              }, "-", 8, _hoisted_11),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "dark:bg-dark-primary w-6 text-center outline-none text-xs font-bold",
                "onUpdate:modelValue": ($event: any) => ((item.qty) = $event)
              }, null, 8, _hoisted_12), [
                [_vModelText, item.qty]
              ]),
              _createElementVNode("button", {
                onClick: ($event: any) => (item.qty++)
              }, "+", 8, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(Math.round(item.price*item.qty*100)/100), 1),
            _createElementVNode("button", {
              onClick: ($event: any) => {_unref(addItem)(item.name,item.price,item.qty) ; item.qty = 0},
              class: "disabled:opacity-50 dark:text-white",
              disabled: item.qty<=0
            }, "Add", 8, _hoisted_15)
          ]),
          _hoisted_16
        ]))
      }), 128))
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drinks, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1),
            (item.temp==undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "-"))
              : (item.temp==true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "dark:text-white",
                    onClick: ($event: any) => (item.temp=!item.temp)
                  }, "冷", 8, _hoisted_22))
                : (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "dark:text-white",
                    onClick: ($event: any) => (item.temp=!item.temp)
                  }, "热", 8, _hoisted_23)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(item.price) + "(小)", 1),
              (item.bigPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.bigPrice) + "(大）", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  class: "dark:text-white",
                  onClick: ($event: any) => (item.qty--)
                }, "-", 8, _hoisted_29),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "dark:text-white dark:bg-dark-primary w-6 text-center outline-none text-xs font-bold",
                  "onUpdate:modelValue": ($event: any) => ((item.qty) = $event)
                }, null, 8, _hoisted_30), [
                  [_vModelText, item.qty]
                ]),
                _createElementVNode("button", {
                  class: "dark:text-white",
                  onClick: ($event: any) => (item.qty++)
                }, "+", 8, _hoisted_31)
              ]),
              (item.bigPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("button", {
                      class: "dark:text-white",
                      onClick: ($event: any) => (item.qty2--)
                    }, "-", 8, _hoisted_33),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "dark:text-white dark:bg-dark-primary w-6 text-center outline-none text-xs font-bold",
                      "onUpdate:modelValue": ($event: any) => ((item.qty2) = $event)
                    }, null, 8, _hoisted_34), [
                      [_vModelText, item.qty2]
                    ]),
                    _createElementVNode("button", {
                      class: "dark:text-white",
                      onClick: ($event: any) => (item.qty2++)
                    }, "+", 8, _hoisted_35)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(Math.round(item.price*item.qty*100)/100), 1),
              (item.bigPrice )
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(Math.round(item.bigPrice*item.qty2*100)/100), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                class: "dark:text-white disabled:opacity-50",
                disabled: item.qty<=0,
                onClick: ($event: any) => {_unref(addItem)(item.name,item.price,item.qty,item.temp) ; item.qty = 0}
              }, "Add", 8, _hoisted_40),
              (item.bigPrice)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "dark:text-white disabled:opacity-50",
                    disabled: item.qty2<=0,
                    onClick: ($event: any) => {_unref(addItem)(item.name,item.bigPrice,item.qty2,item.temp) ; item.qty2= 0}
                  }, "Add", 8, _hoisted_41))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_42
        ]))
      }), 128))
    ]),
    _hoisted_43,
    _createElementVNode("div", _hoisted_44, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beer, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", null, _toDisplayString(item.price) + " (Can)", 1),
              _createElementVNode("div", null, _toDisplayString(item.bigPrice) + " (Bottle)", 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (item.qty--)
                }, "-", 8, _hoisted_50),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "dark:bg-dark-primary w-6 text-center outline-none text-xs font-bold",
                  "onUpdate:modelValue": ($event: any) => ((item.qty) = $event)
                }, null, 8, _hoisted_51), [
                  [_vModelText, item.qty]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (item.qty++)
                }, "+", 8, _hoisted_52)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (item.qty2--)
                }, "-", 8, _hoisted_54),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "dark:bg-dark-primary w-6 text-center outline-none text-xs font-bold",
                  "onUpdate:modelValue": ($event: any) => ((item.qty2) = $event)
                }, null, 8, _hoisted_55), [
                  [_vModelText, item.qty2]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (item.qty2++)
                }, "+", 8, _hoisted_56)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, _toDisplayString(Math.round(item.price*item.qty*100)/100), 1),
              _createElementVNode("div", _hoisted_59, _toDisplayString(Math.round(item.bigPrice*item.qty2*100)/100), 1)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("button", {
                onClick: ($event: any) => {_unref(addItem)(item.name,item.price,item.qty) ; item.qty= 0},
                class: "dark:text-white disabled:opacity-50",
                disabled: item.qty<=0
              }, "Add", 8, _hoisted_61),
              _createElementVNode("button", {
                onClick: ($event: any) => {_unref(addItem)(item.name,item.bigPrice,item.qty2) ; item.qty2= 0},
                class: "dark:text-white disabled:opacity-50",
                disabled: item.qty2<=0
              }, "Add", 8, _hoisted_62)
            ])
          ]),
          _hoisted_63
        ]))
      }), 128))
    ]),
    _hoisted_64,
    _createElementVNode("div", _hoisted_65, [
      (_unref(addedItem).length==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_66, "No items added."))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(addedItem), (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("img", {
                      onClick: ($event: any) => (_unref(removeItem)(index)),
                      src: _imports_0,
                      class: "w-4 h-4 cursor-pointer"
                    }, null, 8, _hoisted_69),
                    _createElementVNode("span", _hoisted_70, _toDisplayString(item.name), 1),
                    (item.cold!=undefined && item.cold)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_71, "(冷)"))
                      : (item.cold!=undefined && !item.cold)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_72, "(热)"))
                        : _createCommentVNode("", true),
                    (item.bigPrice!=undefined && !item.bigPrice)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_73, "(小)"))
                      : (item.bigPrice!=undefined && item.bigPrice)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_74, "(大)"))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_75, "x" + _toDisplayString(item.qty), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, _toDisplayString(Math.round(item.total*100)/100), 1)
              ])
            ]))
          }), 128)),
      (_unref(addedItem).length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _hoisted_78,
            _createElementVNode("div", _hoisted_79, _toDisplayString(_unref(totalCost)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (saveTemporary())),
          class: "text-white bg-orange-primary px-3 py-1.5 mt-2 rounded-lg"
        }, "Save as Temporary Order"),
        (_unref(addedItem).length>0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (saveOrder())),
              class: "text-white bg-purple-primary px-3 py-1.5 mt-2 rounded-lg"
            }, "Confirm and Save Order"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})